import React from 'react';
import Reflux from 'reflux';
import UIRegions from 'shared/constants/UIRegions';
import Messages from 'shared/constants/Messages';
import GlobalElementStore from 'flux/stores/GlobalElementStore';
import GuestPassStore from 'flux/stores/GuestPassStore';
import UserSessionStore from 'flux/stores/UserSessionStore';
import GuestPassModal from 'main/components/event/guestPassModal';

export default React.createClass({
  displayName: 'GuestPassModal',

  mixins: [
    Reflux.connectFilter(GlobalElementStore, 'show', (state) =>
      state.get('activeElementSet'),
    ),
    Reflux.connectFilter(GlobalElementStore, 'showList', (state) =>
      state.get('elementSets'),
    ),
    Reflux.connectFilter(GlobalElementStore, 'event', (state) =>
      state.get('event'),
    ),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connect(GuestPassStore, 'guestPass'),
  ],

  getInitialState() {
    return {};
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    const params = this.context.router.state.params;
    const { event } = this.state;
    const { teamId } = params;
    const eventId = event ? event.get('_id') : '';

    return (
      <GuestPassModal
        modalType={UIRegions.GlobalElementsGuestPass}
        {...this.state}
        {...{ teamId, eventId }}
        title="GE Manager Guest Pass"
        description={Messages.guestPassGlobalElementDescription}
      />
    );
  },
});
